import { render, staticRenderFns } from "./m-addTopicSNPMB.vue?vue&type=template&id=267236e6&"
import script from "./m-addTopicSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-addTopicSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports